import React from 'react';
import { DownloadIcon, LogoIcon, PaidIcon } from '../../../assets/icons';
import './styles.scss';

const BillDetail = (props) => {
  const renderHeader = (
    <header className='bill-header'>
      <h1 className='h1'>
        <span>فاكتور</span>
        <span className='site-name'>#4344323</span>
      </h1>
      <p className='description'>
        برای نصب رایچت بر روی وب سایت میتونید از یکی از روش های دستی یا افزونه
        استفاده کنید.
      </p>
    </header>
  );

  const renderTitleRow = (
    <div className='row title-wrapper'>
      <div className='avatar'>
        <img src={LogoIcon} alt='' />
        <h1>رايچت</h1>
      </div>
      <h1>فاكتور فروش</h1>
      <div>
        <div className='number-wrapper'>
          <div className='name'>شماره</div>
          <div>4344323</div>
        </div>
        <div>
          <div className='name'>تاريخ</div>
          <div>1400/01/02</div>
        </div>
      </div>
    </div>
  );

  const renderSellerRow = (
    <div className='row'>
      <div>
        <div className='name seller'>فروشنده</div>
        <div className='seller-value'>رايان ارتباط چابک تحليل</div>
      </div>
      <div>
        <div className='name'>کد اقتصادی</div>
        <div>۴۱۱۶۱۸۹۸۸۹۳۴</div>
      </div>
      <div>
        <div className='name'>شماره ثبت</div>
        <div>۷۶۴۵۷۶</div>
      </div>
      <div>
        <div className='name'>شناسه ملی</div>
        <div>۱۴۰۰۷۴۹۲۳۲۰</div>
      </div>
      <div>
        <div className='name'>کد پستی</div>
        <div>۱۵۹۱۶۳۹۷۴۸</div>
      </div>
    </div>
  );

  const renderSellerAddress = (
    <div className='row address-wrapper'>
      <div>
        <div className='name'>آدرس پستی</div>
        <div>
          طهران مرکزی میدان ولی عصر خیابان انقلاب اسلامی کوچه شهید ابوالقاسم
          بالاور پلاک 7 طبقه دوم-۰۲۱۷۸۷۵۶۹۳۴
        </div>
      </div>
    </div>
  );

  const renderBuyerRow = (
    <div className='row buyer-wrapper'>
      <div>
        <div className='name buyer'>خریدار</div>
        <div>فن آوران ایده پرداز سززمین هنر</div>
      </div>
      <div>
        <div className='name'>کد اقتصادی</div>
        <div>۴۱۱۶۱۸۹۸۸۹۳۴</div>
      </div>
      <div>
        <div className='name'>شماره ثبت</div>
        <div>۷۶۴۵۷۶</div>
      </div>
      <div>
        <div className='name'>شناسه ملی</div>
        <div>۱۴۰۰۷۴۹۲۳۲۰</div>
      </div>
      <div>
        <div className='name'>کد پستی</div>
        <div>۱۵۹۱۶۳۹۷۴۸</div>
      </div>
    </div>
  );

  const renderBuyerAddress = (
    <div className='row address-wrapper'>
      <div>
        <div className='name'>آدرس پستی</div>
        <div>
          طهران مرکزی میدان ولی عصر خیابان انقلاب اسلامی کوچه شهید ابوالقاسم
          بالاور پلاک 7 طبقه دوم-۰۲۱۷۸۷۵۶۹۳۴
        </div>
      </div>
    </div>
  );

  const renderPriceSection = (
    <div className='row table-wrapper'>
      <div className='table-row'>
        <div className='name'>شرح</div>
        <div className='name'>بازه زمانی</div>
        <div className='name'>مبلغ</div>
      </div>
      <div className='table-row tbody'>
        <div>پکیج تجاری، یک ساله</div>
        <div>1398/01/29 - 1399/10/30</div>
        <div>4,925,000</div>
      </div>
      <div className='table-row tfooter'>
        <div className='badge-wrapper'>
          <img src={PaidIcon} alt='' />
        </div>
        <div></div>
        <div>
          <ul>
            <li>
              <span>مجموع</span>
              <span>4,925,000</span>
            </li>
            <li>
              <span>اعتبار قبلی</span>
              <span>25,000</span>
            </li>
            <li>
              <span>تخفیف</span>
              <span>100,000</span>
            </li>
            <li>
              <span>مالیات</span>
              <span>398,929</span>
            </li>
            <li>
              <span>ارسال پستی</span>
              <span>35,000</span>
            </li>
            <li>
              <span>مبلغ کل</span>
              <span>5,424,782 تومان</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {renderHeader}
      <section className='bill-detail'>
        {renderTitleRow}
        {renderSellerRow}
        {renderSellerAddress}
        {renderBuyerRow}
        {renderBuyerAddress}
        {renderPriceSection}
      </section>
      <footer className='bill-footer'>
        <div></div>
        <a className='download-button' href='#/'>
          <img src={DownloadIcon} alt='' />
          <span>دانلود صورتحساب</span>
        </a>
      </footer>
    </>
  );
};

export default BillDetail;
